import React, { useEffect, useRef, useState } from "react";
import TouchIcon from "../icons/TouchIcon";

const CallToAction: React.FunctionComponent<{}> = () => {
  const backgroundRef = useRef<HTMLDivElement>(null);
  const [color, setColor] = useState<string>("bg-red-700/50");

  useEffect(() => {
    if (
      backgroundRef.current &&
      getComputedStyle(backgroundRef.current).getPropertyValue("--rf-primary")
    ) {
      setColor("bg-frameworkPrimary/50");
    } else {
      setColor("bg-red-700/50");
    }
  }, [backgroundRef]);
  
  return (
    <div
      className="absolute bottom-0 right-0 w-80 h-80 grid grid-cols-1 grid-rows-1 justify-end justify-items-end content-end items-end text-center overflow-hidden z-10"
    >
      <div
        ref={backgroundRef}
        className={`relative col-start-1 col-end-2 row-start-1 row-end-2 w-48 h-36 ${color} rotate-45 translate-y-8`}
      ></div>
      <div className="relative col-start-1 col-end-2 row-start-1 row-end-2 h-32 w-50 flex flex-col gap-2 justify-center items-center text-white">
        <TouchIcon className="h-12 w-12" />
        <p className="mx-4">Click on screen to start</p>
      </div>
    </div>
  );
};

export default CallToAction;
